module.exports = __webpack_public_path__ + "static/sport/bgi-form.d111aed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump/bgi-form.png
// module id = rUIr
// module chunks = 0